module.exports = __webpack_public_path__ + "img/M.45d09998.png";